// Regras de status de contrato na tela (espelham Models/Helper/contratos.js do backend).
export const ROTULO_STATUS = { implantacao: 'Em implantação', ativo: 'ativo', suspenso: 'suspenso', encerrado: 'encerrado' };
export const rotuloStatusContrato = (s) => ROTULO_STATUS[s] || s || '—';
// Novo nasce em implantação; implantação só sai p/ ativo pela Homologação (ou encerra);
// ninguém volta p/ implantação — exceto o encerrado nunca homologado (revisão final,
// item 4), que só volta para implantação. nuncaHomologado null = não se sabe se houve
// homologação: oferece também ativo e o backend (a autoridade) recusa com a mensagem.
export const opcoesStatusContrato = (original, { nuncaHomologado = false } = {}) => {
    if (!original) return ['implantacao'];
    if (original === 'implantacao') return ['implantacao', 'encerrado'];
    if (original === 'encerrado' && nuncaHomologado === true) return ['encerrado', 'implantacao'];
    if (original === 'encerrado' && nuncaHomologado === null) return ['encerrado', 'implantacao', 'ativo'];
    return ['ativo', 'suspenso', 'encerrado'];
};

// Criado a partir de 06/10/2026 (data local) e sem evento de homologação
// (tem_homologacao vem da lista de contratos do cliente). null = não se sabe.
export const DATA_CORTE_HOMOLOGACAO = '2026-10-06';
export const contratoNuncaHomologado = (contrato) => {
    if (!contrato || !contrato.created_at) return false;
    const d = new Date(contrato.created_at);
    if (Number.isNaN(d.getTime())) return false;
    const ymd = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    if (ymd < DATA_CORTE_HOMOLOGACAO) return false;
    if (contrato.tem_homologacao === undefined || contrato.tem_homologacao === null) return null;
    return !Number(contrato.tem_homologacao);
};
export const editavelNoItens = (s) => s === 'ativo' || s === 'implantacao';

export const rotuloTipoContrato = (t) => (t === 'global' ? 'Global' : 'Por itens');

// Busca da aba Contratos (customSearchFunction da DataTable, que sozinha só olha
// as chaves das colunas): nome, número, tipo e status — sem acento e sem caixa.
const semAcento = (v) => String(v == null ? '' : v).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export const buscaContrato = (ct, termo) => {
    const t = semAcento(termo).trim();
    if (!t) return true;
    const c = ct || {};
    return [c.nome, c.numero, c.tipo, c.tipo ? rotuloTipoContrato(c.tipo) : '', c.status, c.status ? rotuloStatusContrato(c.status) : '']
        .some((campo) => semAcento(campo).includes(t));
};
